const NAME_KEY = "cs_player_name";
const SESSION_PREFIX = "cs_session_"; // cs_session_<code> => { player_id, name }
const VISITED_KEY = "cs_visited";

export const getStoredName = () => {
  try { return localStorage.getItem(NAME_KEY) || ""; } catch { return ""; }
};
export const setStoredName = (name) => {
  try { localStorage.setItem(NAME_KEY, name); } catch {}
};

export const getSession = (code) => {
  try {
    const raw = localStorage.getItem(SESSION_PREFIX + code);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
};
export const setSession = (code, session) => {
  try { localStorage.setItem(SESSION_PREFIX + code, JSON.stringify(session)); } catch {}
  recordVisit(code, session?.name);
};
export const clearSession = (code) => {
  try { localStorage.removeItem(SESSION_PREFIX + code); } catch {}
};

export const recordVisit = (code, name) => {
  if (!code) return;
  try {
    const list = JSON.parse(localStorage.getItem(VISITED_KEY) || "[]");
    const filtered = list.filter((v) => v.code !== code);
    filtered.unshift({ code, name: name || "", ts: Date.now() });
    localStorage.setItem(VISITED_KEY, JSON.stringify(filtered.slice(0, 20)));
  } catch {}
};

export const getVisited = () => {
  try { return JSON.parse(localStorage.getItem(VISITED_KEY) || "[]"); } catch { return []; }
};

export const removeVisited = (code) => {
  try {
    const list = JSON.parse(localStorage.getItem(VISITED_KEY) || "[]");
    localStorage.setItem(VISITED_KEY, JSON.stringify(list.filter((v) => v.code !== code)));
  } catch {}
};
